import template from './state.html';
import controller from './state.controller';
import './state.scss';

let stateComponent = {
  bindings: {},
  template,
  controller
};

export default stateComponent;



// WEBPACK FOOTER //
// ./client/app/components/state/state.component.js